export default {
  headers: {
    guest: 'Guest',
    without_room: 'Without room',
    guest_checkin: 'Guest check-in',
    data_registry: 'Data registry',
    data_validation: 'Data validation',
    contact_data: 'Contact data',
    accept_terms_and_conditions: 'Accept terms and conditions',
    guest_checkin_completed: 'Guest data',
    personal_data: 'Personal data',
    terms_of_service: 'Terms of Service',
    room: 'Room',
    password: 'Set your password for future access',
    emails_linked: 'Emails linked to this booking',
  },
  success: {
    settings: 'Settings has been saved',
    change_password: 'The new password has been saved',
    contact_data: 'Contact data has been saved',
    checkin: 'Check-in data has been saved',
    payment_completed: 'Payment completed',
  },
  error: {
    no_data: 'No data',
    not_found: 'Oops! Could not find what you were looking for',
    guest_id: 'Guest not found',
    change_password: 'The current password is not correct',
    server_disconnected: 'Server not reachable',
    too_many_requests_exception: 'Oops! The system has received too many requests, please try again in {time}s',
    server_error: 'Server error',
    forbidden: 'Forbidden action',
    not_enough_balance: 'Not enough balance',
    disabled_account: 'Account has been disabled',
    disabled_guest: 'The guest in whose name reservation was attempted has been disabled',
    limit_exceded: 'Consumption limit would be exceeded with this reservation',
    payment_error: 'There was an error during payment',
    requested_date: {
      not_available: {
        ROOM_SERVICE: 'It seems like you took too long finishing your order. Select a different delivery time',
        IN_VENUE: 'It seems like you took too long finishing your reservation. Select a different reservation time',
      },
    },
    available_slots: {
      hour_is_passed: {
        ROOM_SERVICE: 'It seems like you took too long finishing your order. Select a different delivery time',
        IN_VENUE: 'It seems like you took too long finishing your reservation. Select a different reservation time',
      },
      final_hour_is_passed: {
        ROOM_SERVICE: 'It seems like you took too long finishing your order. Select a different delivery time',
        IN_VENUE: 'It seems like you took too long finishing your reservation. Select a different reservation time',
      },
      not_in_range: {
        ROOM_SERVICE: 'It seems like you took too long finishing your order. Select a different delivery time',
        IN_VENUE: 'It seems like you took too long finishing your reservation. Select a different reservation time',
      },
      generic: 'An error ocurred. Check the entered data or ask staff for help',
    },
    cannot_reserve_from: {
      ROOM_SERVICE: 'It seems like you took too long finishing your order. Select a different delivery time',
      IN_VENUE: 'It seems like you took too long finishing your reservation. Select a different reservation time',
    },
    minimum_moment_for_reserve: {
      ROOM_SERVICE: 'It seems like you took too long finishing your order. Select a different delivery time',
      IN_VENUE: 'It seems like you took too long finishing your reservation. Select a different reservation time',
    },
    maximum_capacity_exceeded: {
      ROOM_SERVICE: 'Someone made an order while you were checking out and there\'s no longer availability for your selected time. Please, select a different delivery time',
      IN_VENUE: 'Someone made a reservation while you were browsing and there\'s no longer availability for your selected time. Please, select a different reservation time',
    },
    title: {
      failed_payment: 'The payment has failed',
      processing_payment: 'We are processing the payment',
    },
    text: {
      failed_payment: 'The reservation will be accepted once the payment is completed',
      processing_payment: 'You will receive a confirmation email when it is processed. You can see the updated status of the reservation in the <span class="font-weight-bold">{dashboardName}</span> section.',
    },
  },
  document_scan_tips: {
    tip_1: 'Make sure your document is legible and centered',
    tip_2: 'The corners of your document must be visible',
    tip_3: 'Reduce light reflection as much as possible',
  },
  measurement_unit: {
    ms: 'ms',
    s: 's',
    min: 'min',
    h: 'h',
    day: 'd',
    year: 'y',
    minute_quantified: '0 minutes | 1 minute | {count} minutes',
    hour_quantified: '0 hours | 1 hour | {count} hours',
    day_quantified: '0 days | 1 day | {count} days',
    year_quantified: '0 years | 1 year | {count} years',
  },
  actions: {
    loading: 'Loading...',
    sign_in: 'Sign in',
    sign_out: 'Sign out',
    edit_settings: 'Edit settings',
    change_password: 'Change password',
    save: 'Save',
    cancel: 'Cancel',
    select: 'Select',
    dismiss: 'Dismiss',
    front_side_photo: 'Front side photo',
    back_side_photo: 'Back side photo',
    next: 'Next',
    back: 'Back',
    checkin_start: 'Start process',
    checkin_in_progress: 'Continue process',
    checkin_completed: 'Completed',
    download_signed_document: 'Download signed document',
    open_terms_of_service: 'Open terms of service',
    close: 'Close',
    accept: 'Accept',
    clear_signature: 'Delete signature signature',
    set_password: 'Set password',
    ignore_for_now: 'Ignore for now',
    upload_photo: 'Take photo',
    continue: 'Continue',
    confirm: 'Confirm',
    go_back: 'Go back',
    make_payment: 'Make payment',
    refresh: 'Refresh',
  },
  time_format: {
    AM_PM: 'AM/PM',
    H_24: '24h',
  },
  first_day_of_week: {
    MONDAY: 'MONDAY',
    FRIDAY: 'FRIDAY',
    SATURDAY: 'SATURDAY',
    SUNDAY: 'SUNDAY',
  },
  gender: {
    male: 'Male',
    female: 'Female',
    other: 'Other',
  },
  document_type: {
    ID_CARD: 'ID Card',
    PASSPORT: 'Passport',
  },
  fields: {
    name: 'Name',
    surname: 'Surname',
    phone: 'Phone',
    birthdate: 'Birthdate',
    email: 'E-mail',
    password: 'Password',
    sign_in_email: 'Sign in e-mail',
    language: 'Language',
    old_password: 'Old password',
    new_password: 'New password',
    repeat_new_password: 'Repeat new password',
    payment_account: 'Payment account',
    checkin: 'Checkin',
    checkout: 'Checkout',
    nationality: 'Nationality',
    document_type: 'Document type',
    gender: 'Gender',
    address: 'Address',
    document_expiration: 'Document expiration',
    checkin_step2_confirm: 'I confirm all my data is complete and correct',
    country: 'Country',
    place_of_birth: 'Place of birth',
    document: 'Document',
    date: 'Date',
    time: 'Time',
    adults: 'Adults',
    children: 'Children',
    guest: 'Guest',
    in_whose_name: 'In whose name',
    signature: 'Signature',
    sign_here: 'Sign here',
    room: 'Room',
    comments: 'Comments',
    requested_date: 'Requested date',
    attendees: 'Attendees',
    reason: 'Reason',
    display_currency: 'Display currency',
    you: 'You',
    time_format: 'Time format',
    first_day_of_week: 'First day of week',
  },
  main: {
    loading_bookings: 'Loading booking...',
    no_bookings: 'There are no active bookings',
    cookies_policy: 'Cookies notice',
    privacy_policy: 'Privacy policy',
  },
  cookies: {
    cookies_not_shown_in_localhost: 'Cookie declaration notice not available at development environments.',
    cookie_modal_id_not_specified: 'Cookie modal ID not specified in configuration.',
  },
  account_options: {
    booking: 'Booking',
    room: 'Room',
    guest: 'Guest',
  },
  accounts: {
    postpaid_currency: 'Postpaid currency',
    no_selected_currencies: 'No selected currencies',
    select_currencies: 'Select currencies for filter transactions',
    balance_by_currencies: 'Balance by currencies',
    remove_all_filters: 'Remove all filters',
    show_more: 'Show more',
    show_less: 'Show less',
    show_all: 'Show all',
    close: 'Close',
    apply_filters: 'Apply filters',
    balance: 'Balance',
    deactivated_account: 'Deactivated account',
    no_more_transactions: 'There are no more transactions',
    no_transactions: 'No transactions',
  },
  checkin: {
    no_name: 'No name',
    exempt: 'Unrequired registration',
    image_crop: {
      crop_tip: 'Fit the selection to the document',
      confirm: 'Is the document data visible?',
      instructions: 'Fit the stencil around the document so that every corner fits inside it. Rotate the image as necessary.',
      actions: {
        crop_image: 'Crop image',
        rotate: 'Rotate',
        edit_again: 'Edit again',
      },
    },
  },
  validations: {
    messages: {
      required: 'Required',
      min: 'This field must have no less than {length} characters',
      max: 'This field can only have {length} characters',
      email: 'This field must be a valid email',
      confirmed: 'The password fields must match',
    },
  },
  login: {
    access_mail_sent: 'If there is a user with this email, they will receive an access e-mail shortly.',
    error: 'Something went wrong and your credentials could not be sent. Please try again later.',
    log_in_with_password: 'Enter my password',
    enter_to_password: 'Enter your password',
    send_access_link: 'Send me a magic link',
    info_access_link:'This option will give you immediate access to your account without a password',
    check_your_email: 'Check your email',
    success_access_link:'The magic link has been sent to the email provided.',
    authentication: 'Authentication',
    access_route: 'In order to gain access to this content please sign in',
    welcome: 'Welcome to the guest web portal!',
    instructions: 'Please enter your details in order to gain access to your account',
    dont_send_email: 'Did not receive the email? Please check your spam folder or',
    try_diferent_email: 'try a different email',
    or: 'or',
    no_account: 'No account?',
    create_one: 'Create one!',
  },
  texts: {
    waiting_validation: 'Waiting for data validation',
    be_patient: 'Please, be patient. This process might take some time.',
    document_scan_failed: {
      INVALID_RESPONSE: 'The validation service is not available. Please try again later.',
      INVALID_RESPONSE_BODY: 'Validation failed. Take new photos and make sure your document is legible and correctly aligned.',
      INVALID_CHECK_NUMBERS: 'Validation failed. Take new photos and make sure your document is legible and correctly aligned.',
      MISSING_REQUIRED_DATA: 'Validation failed. Take new photos and make sure your document is legible and correctly aligned.',
    },
    document_expired: 'Your document is expired. You can\'t continue the process as long as your provided document is expired. Please provide a different document.',
    without_account: 'The reservation doesn\'t have associated accounts',
  },
  activity_reservation: {
    name: 'Reservation',
    reservation: 'reservation',
    order: 'order',
    title: 'Confirm your {entityType}',
    summary_warning: 'Review your data and confirm to complete your reservation',
    registered_reservation: 'The reservation has been made and is now available in the <span class="font-weight-bold">{dashboardName}</span> section.',
    slot_notification_min: {
      ROOM_SERVICE: 'You can make an order up to {time} before your desired delivery time.',
      IN_VENUE: 'You can make a reservation up to {time} before your desired time slot.',
    },
    slot_notification_max: {
      ROOM_SERVICE: 'The soonest you can order is {time} before your desired delivery time.',
      IN_VENUE: 'The soonest you can make a reservation is {time} before your desired time slot.',
    },
    leeway_time_before_activity_service_start: {
      ROOM_SERVICE: 'The latest you can make an order is {time} before in-service hours start.',
      IN_VENUE: 'The latest you can make a reservation is {time} before in-service hours start.',
    },
    leeway_time_before_activity_service_start_init: {
      ROOM_SERVICE: 'You can\'t make an order once service hours start.',
      IN_VENUE: 'You can\'t make a reservation once service hours start.',
    },
    fully_booked: 'Sorry, fully booked',
    actions: {
      back: {
        IN_VENUE: 'Back to reservation',
        ROOM_SERVICE: 'Back to order',
      },
      confirm: 'Confirm',
      confirm_and_pay: 'Confirm and pay',
      check: 'Check {entityType}',
      browse_other_activities: 'Browse other activities',
      manage: 'Manage',
      go_to_updated: {
        IN_VENUE: 'Go to updated reservation',
        ROOM_SERVICE: 'Go to updated order',
      },
      see_all: 'See all',
      see_past_reservations: 'See past reservations',
    },
    error: {
      error: 'There was an error',
      generic_error_1: 'Oops! It seems like something went wrong',
      generic_error_2: 'If the problem persists, our staff will be glad to help.',
      back: 'Back',
      retry: 'Try again',
      history_error: 'Unable to retrieve reservation history at the moment',
      required_field: 'Required field',
      webapp_payment_method: {
        refund: 'Contact the staff, validation of the refund by the payment processor is required.',
      },
    },
    warning: {
      some_product_included: 'One or more products in your order are already included in your stay.',
      minimum_order_units: ' | Add {qtyProducts} more products to your cart and complete your order. | Add {qtyProducts} more products to your cart and complete your order.',
      no_checkin_or_checkout: 'Some related booking has no checkin or checkout',
      reservation_method_first_date: 'Available from {date} at {hour} onwards.',
      reservation_method_no_room: 'Requires a room in booking.',
      no_booking: 'Booking required',
      select_payment_method: 'Select a payment method',
      no_payment_methods: 'There are no available payment methods',
    },
    edit: {
      title: 'Manage reservation',
      pending_modification: 'Your reservation is currently pending confirmation by the host.',
      must_be_approved: 'You can send a request to modify your reservation. Changes will apply once approved by the host.',
      unavailable_edition: {
        IN_VENUE: 'Modification available up to {time} before the reservation time',
        ROOM_SERVICE: 'Modification available up to {time} before the order time',
      },
      unavailable_cancellation: {
        IN_VENUE: 'Cancellation available up to {time} before the reservation time',
        ROOM_SERVICE: 'Cancellation available up to {time} before the order time',
      },
      manage_past_limit: {
        IN_VENUE: 'In order to cancel or modify a past reservation, please contact our staff',
        ROOM_SERVICE: 'In order to cancel or modify a past order, please contact our staff',
      },
      permission: 'I understand that in case the host does not approve this request, my reservation will be cancelled, and that this modifcation request cannot be reverted.',
      request_modification: 'Request modification',
      modify: {
        IN_VENUE: 'Modify reservation',
        ROOM_SERVICE: 'Modify order',
      },
      cancel: {
        IN_VENUE: 'Cancel reservation',
        ROOM_SERVICE: 'Cancel order',
      },
      cancellation_success: {
        IN_VENUE: 'Reservation successfully cancelled',
        ROOM_SERVICE: 'Order successfully cancelled',
      },
      cancellation_error: 'Error during cancellation request',
      modification_success: {
        IN_VENUE: 'Successfully modified reservation',
        ROOM_SERVICE: 'Successfully modified order',
      },
      modification_pending: 'Waiting for modification approval',
      modification_error: 'Error during modification request',
      order_refund_disclaimer: 'A refund will be automatically generated if cancelled.',
    },
    complete: {
      IN_VENUE: 'Reservation complete',
      ROOM_SERVICE: 'Order complete',
    },
    pending: 'Pending confirmation',
    visit_reservations_prompt: 'You can find your {entityType} info on <span class="font-weight-bold">{dashboardName}</span>',
    confirmation_prompt_reservation: 'You will receive an email when reservation is accepted.',
    confirmation_prompt_order: 'You will receive an email when your order is accepted.',
    no_children_allowed: 'No children allowed',
    over_capacity: 'The number of attendees for the selected time slot is over the set capacity',
    reached_capacity: 'Capacity reached',
    deliver_to_room: 'To be delivered in room',
    account_text: 'Select your payment account. Product prices and quantities will be displayed based on the balance on the selected account.',
    details: 'Details',
    reservation_price: 'Reservation price',
    total: 'Total',
    subtotal: 'Subtotal',
    attendee_type: 'Number of {type}',
    max_attendee_type: 'The maximum number of attendees is {maxAttendeesPerReservation}',
    delivery_terms: 'Delivery terms',
    booking_terms: 'Booking terms',
    another_reservation_restriction: 'You already have a reservation for {activityName} at {activityTime}. To continue, please contact a staff member or choose another time.',
    service_charge: 'Service charge {serviceCharge}%',
    payment_method: 'Payment method',
    room_charge: 'Room charge',
    amount_to_be_paid: 'Amount to be paid',
    no_upcoming_reservations: 'No upcoming reservations',
    created_by_modification_notice: {
      ROOM_SERVICE: 'This is a new order created by an operator and replaces another order made by you which was canceled',
      IN_VENUE: 'This is a new reservation created by an operator and replaces another reservation made by you which was canceled',
    },
  },
  upcoming_events: {
    no_events: 'There are no events',
    no_events_today: 'No events today',
    see_future_events: 'Browse other days',
    requires_reservation: 'Requires reservation',
    today: 'Today',
    select_prompt: 'Select the categories you are interested in',
    more: 'more',
    select_categories: 'Filter by category',
    actions: {
      select_all: 'Select all',
      deselect_all: 'Deselect all',
    },
  },
  activities: {
    by_category: 'Browse by category',
    details: {
      see_timetable: 'See opening hours',
      closed: {
        IN_VENUE: 'Closed right now',
        ROOM_SERVICE: 'Accepting pre-orders',
      },
      open: 'Open',
      timetable: 'Opening hours',
      related_activities: 'You may also like...',
    },
    dow: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
    },
    reservation_types: {
      IN_VENUE: 'Reservation',
      ROOM_SERVICE: 'Room delivery',
      EXTERNAL_RESERVATION_SYSTEM: 'External reservation system',
    },
  },
  sign_out: {
    warning: 'Are you sure you want to sign out?',
    no_password: 'If you sign out without setting a password, you will need to sign in using the link in your e-mail next time.',
  },
  reservations: {
    upcoming: 'Upcoming',
    past: 'Past',
    all: 'All',
    log_status: {
      PAYMENT_ATTEMPT: 'Payment failed',
      PAID: 'Paid',
      SUCCESS: 'Paid',
      REFUNDED: 'Refund',
      REFUSED: 'Payment failed',
    },
    status: {
      PENDING: 'Pending approval',
      ACCEPTED: 'Accepted',
      REJECTED: 'Rejected',
      ATTENDED: 'Completed',
      ABSENT: 'No show',
      CANCELLED: 'Cancelled',
      PENDING_MODIFICATION: 'Pending approval',
      ACCEPTED_BY_ACTIVITY_MODIFICATION: 'Changed by staff',
      CANCELLED_BY_ACTIVITY_MODIFICATION : 'Cancelled & changed',
      PENDING_PAYMENT: 'Pending payment',
    },
    short_status: {
      PENDING: 'Pending',
      PENDING_MODIFICATION: 'Pending',
      ACCEPTED_BY_ACTIVITY_MODIFICATION: 'Accepted',
      CANCELLED_BY_ACTIVITY_MODIFICATION : 'Cancelled',
      UPCOMING: 'Upcoming',
    },
    order_status: {
      ATTENDED: 'Delivered',
    },
    order_short_status: {
      ATTENDED: 'Delivered',
    },
    details_tabs: {
      TIMELINE: 'Timeline',
      DETAILS: 'Details',
    },
    timeline_status: {
      confirmed: 'Confirmed',
      updated: 'Updated',
      accepted_by_activity_modification: {
        IN_VENUE: 'Confirmed',
        ROOM_SERVICE: 'Confirmed',
      },
      cancelled_by_activity_modification: {
        IN_VENUE: 'Cancelled & changed',
        ROOM_SERVICE: 'Cancelled & changed',
      },
      pending_approval: 'Pending approval',
      requested_modification: 'Requested modification',
      payment: 'Payment',
    },
    hide_timeline: 'Hide status timeline',
    finished: {
      IN_VENUE: 'Your reservation has finished',
      ROOM_SERVICE: 'Your order has finished',
    },
    refund_emitted: 'Refund was emitted',
    no_account: 'No payment account',
    guest_type_not_selectable: 'Guest type not allowed',
    inactive_account: 'Inactive account',
    no_more_reservations: 'There are no more reservations',
    no_reservations: 'No reservations',
    inactive_guest: 'Inactive guest',
    show_more: 'Show more',
    details: 'Details',
    reservation_date: 'Booked date ',
    room: 'Deliver to ',
    booked_at: 'Booked for ',
    estimated_at: 'Estimated at ',
    go_to_previous: {
      IN_VENUE: 'Go to previous reservation',
      ROOM_SERVICE: 'Go to previous order',
    },
    estimated_at: {
      IN_VENUE: 'Booked for ',
      ROOM_SERVICE: 'Estimated at ',
    },
    requested_for: {
      IN_VENUE: 'Booked for ',
      ROOM_SERVICE: 'Requested for ',
    },
    adults: 'Adults ',
    children: 'Children ',
    title: 'Your {entityType}',
    comments: {
      ROOM_SERVICE: 'Leave a comment or instructions',
      IN_VENUE: 'Special instructions...',
    },
    ticket: 'Receipt',
    see_details: 'See details',
    refund_ticket: 'Refund receipt',
    categories: 'Categories',
    products: 'Products',
    card_used: 'Card used',
  },
  catalog: {
    view_order: 'View order',
    cancel: 'Cancel',
    update_product: 'Update product',
    how_many: 'How many...?',
    you_may_also_like: 'You may also like…',
    do_payment: 'Proceed to payment',
    confirm_order: 'Confirm order',
    out_of_stock: 'Out of stock',
    remove: 'Remove',
    empty_cart: 'No selected products',
    tax: 'Tax',
    product_quantity: '{qty} products | {qty} product | {qty} products',
    product_quantity_short: '{qty} prods | {qty} prod | {qty} prods',
    min_selected: '{min} min',
    max_selected: '{max} max',
    actions: {
      add: 'Add',
      remove: 'Remove',
      update: 'Update',
      see_details: 'See details',
    },
  },
  pages: {
    content: {
      dresscode: 'Dresscode',
      people_also_liked: 'People also liked',
      weekly_schedule: 'Weekly schedule',
    },
    opening_hours: {
      closed: 'Closed',
      schedule: {
        now: 'Open now',
        open: 'Opens {day} at {startHour}',
        close: 'Closes at {endHour}',
      },
    },
    reservation_type: {
      in_venue_required: 'Reservation required',
      in_venue: 'Reservation',
      room_service: 'Room service',
    },
    reservation_list_types: {
      in_venue: 'Reservations',
      room_service: 'Orders',
      all: 'All',
    },
  },
  no_reservations: {
    base: 'No {status} {type}',
    type: {
      ALL: 'events',
      ROOM_SERVICE: 'orders',
      IN_VENUE: 'reservations',
    },
    status: {
      all: {
        ROOM_SERVICE: '',
        IN_VENUE: '',
      },
      upcoming: {
        ROOM_SERVICE: 'upcoming',
        IN_VENUE: 'upcoming',
      },
      past: {
        ROOM_SERVICE: 'past',
        IN_VENUE: 'past',
      },
    },
  },
}
